"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenKeys = void 0;
function listenKeys(store, keys, listener) {
    let keysSet = new Set([...keys, undefined]);
    return store.listen((value, changed) => {
        if (keysSet.has(changed)) {
            listener(value, changed);
        }
    });
}
exports.listenKeys = listenKeys;
